<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" size="mini" style="width: 200px;" class="filter-item" :placeholder="'名称'" v-model="listQuery.key"> </el-input>
        <el-button class="filter-item" size="mini" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <permission-btn size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table
          style="height:calc(100% - 60px)"
          ref="mainTable"
          :select-type="'checkbox'"
          :table-fields="headerList"
          :data="list"
          :v-loading="listLoading"
          @row-click="rowClick"
          @selection-change="handleSelectionChange"
        ></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="handleCurrentChange" />
      </div>
      <el-dialog v-el-drag-dialog class="dialog-mini" width="500px" :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
        <auth-form ref="dataForm" :rules="rules" :edit-model="true" :form-fields="headerList" v-model="temp" :col-num="1"></auth-form>
        <div slot="footer">
          <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="mini" v-if="dialogStatus == 'create'" type="primary" @click="createData">确认</el-button>
          <el-button size="mini" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog>


      <el-dialog v-el-drag-dialog class="dialog-mini" width="500px" height="300px" title="导入" :visible.sync="importFormVisible">
        <div  class="m-15" @click="downloadTemplate">1、下载导入模版<i class="el-icon-download"></i></div>
        <div class="m-15">2、整理待导入数据到模版中</div>
        <div class="m-15">3、上传文件</div>
        <div class="m-15">
          <el-upload
              ref="upload"
              accept=".xlsx"
              :action="uploadUrl"
              :headers="headers"
              :limit="1"
              :before-upload="checkFileType"
              :on-error="handleUpload"
              :on-success="handleUpload"
              :show-file-list = 'true'
              :auto-upload="false">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
              <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
            </el-upload>
        </div>
        <div slot="footer">
          <el-button size="mini" @click="importFormVisible = false">取消</el-button>
          <el-button size="mini" type="success" @click="importData" v-loading.fullscreen.lock="fullscreenLoading">导入</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as devices from '@/api/devices'
import * as devicePolicies from '@/api/devicePolicies'
import * as manufacturers from '@/api/manufacturers'
import * as productTypes from '@/api/productTypes'
import * as tenants from '@/api/tenants'
import { getToken } from '@/utils/auth'

import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import permissionBtn from '@/components/PermissionBtn'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'
import { defaultVal } from '@/utils/index'
import extend from '@/extensions/common.js'
import AuthForm from '../../components/Base/AuthForm.vue'
import AuthTable from '../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'
export default {
  name: 'device',
  components: { Sticky, permissionBtn, Pagination, AuthTable, AuthForm, },
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  data() {
    return {
      headers:{
        'X-Token':getToken()
      },
      uploadUrl:process.env.VUE_APP_BASE_API+'/devices/import',
      devicePolicies:[],
      manufacturers:[],
      productTypes:[],
      tenants:[],
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        // 查询条件
        page: 1,
        limit: 20,
        key: undefined,
      },
      temp: { },
      dialogFormVisible: false,
      importFormVisible:false,
      fullscreenLoading:false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      statusDef:[
        {value:0,label:'正常'},
        {value:1,label:'过期'},
        {value:2,label:'封禁'},
      ],
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        sn: [{ required: true, message: 'Sn不能为空', trigger: 'blur' }],
        devPolicyId: [{ required: true, message: '设备策略不能为空', trigger: 'blur' }],
        tenantId: [{ required: true, message: '租户不能为空', trigger: 'blur' }],
        status: [{ required: true, message: '状态不能为空', trigger: 'blur' }]
      },
    }
  },
  created() {
    this.getHeaderList();
    this.getList()
  },
  methods: {
    rowClick(row) {
      this.$refs.mainTable.clearSelection()
      this.$refs.mainTable.toggleRowSelection(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onBtnClicked: function(domId,callback) {
      console.log('you click:' + domId)
      switch (domId) {
        case 'btnAdd':
          this.handleCreate()
          break
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error',
            })
            return
          }
          this.handleUpdate(this.multipleSelection[0])
          break
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error',
            })
            return
          }
          this.handleDelete(this.multipleSelection)
          break
        case 'btnExport':
          this.$refs.mainTable.exportExcel('资源文件', callback)
          break
        case 'btnImport':
          this.handleImport();
          break;
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      devices.getList(this.listQuery).then((response) => {
        this.list = response.data
        this.total = response.count
        this.listLoading = false
      })
    },
    getHeaderList(){
      let that = this;
      let r1= devicePolicies.getList({page:1,limit:1000000});
      let r2 = manufacturers.getList({page:1,limit:1000000});
      let r3 = productTypes.getList({page:1,limit:1000000});
      let r4 = tenants.getList({page:1,limit:1000000});
      Promise.all([r1,r2,r3,r4]).then(results =>{
        that.devicePolicies = results[0].data.map(item=>{return {value:item.id,label:item.name,effectiveDays:item.effectiveDays}});
        that.manufacturers = results[1].data.map(item=>{return {value:item.id,label:item.name}});
        that.productTypes = results[2].data.map(item=>{return {value:item.id,label:item.name}});
        that.tenants = results[3].data.map(item=>{return {value:item.id,label:item.name}});

        this.headerList = [
          new ColumnDefine('id', '主键', false, false, '', '', 'bigint', 'bigint', 'Id'),
          new ColumnDefine('tenantId', '租户', true, true, 'select',  [...that.tenants], 'bigint', 'bigint', 'TenantId'),
          new ColumnDefine('sn', '设备Sn', true, true, 'text', '', 'string', 'varchar', 'Sn'),
          new ColumnDefine('devPolicyId', '设备策略', true, true, 'select', [...that.devicePolicies], 'bigint', 'bigint', 'DevPolicyId'),
          new ColumnDefine('manufacturerId', '厂商', true, true, 'select', [...that.manufacturers], 'bigint', 'bigint', 'ManufacturerId'),
          new ColumnDefine('productTypeId', '产品类型', true, true, 'select', [...that.productTypes], 'bigint', 'bigint', 'ProductTypeId'),
          new ColumnDefine('firmwareVer', '固件版本', true, true, 'text', '', 'string', 'varchar', 'FirmwareVer'),
          new ColumnDefine('hardwareVer', '硬件版本', true, true, 'text', '', 'string', 'varchar', 'HardwareVer'),
          //(0-正常，1-过期，2-封禁)
          new ColumnDefine('status', '状态', true, true, 'select', [...this.statusDef], 'int', 'int', 'Status'),
          new ColumnDefine('activationDate', '激活日期', false, true, 'datetime', '', 'DateTime', 'datetime', 'ActivationDate'),
          new ColumnDefine('expiredIn', '过期日期', false, true, 'date', '', 'DateTime', 'date', 'ExpiredIn'),
          new ColumnDefine('description', '备注', true, true, 'textarea', '', 'string', 'text', 'Description'),

          new ColumnDefine('createdAt', '创建时间', false, false, '', '', 'DateTime', 'datetime', 'CreatedAt'),
          new ColumnDefine('createdBy', '创建人', false, false, '', '', 'string', 'varchar', 'CreatedBy'),
          new ColumnDefine('updatedAt', '最后更新时间', false, false, '', '', 'DateTime', 'datetime', 'UpdatedAt'),
          new ColumnDefine('updatedBy', '最后更新人', false, false, '', '', 'string', 'varchar', 'UpdatedBy'),
        ]
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
    handleModifyStatus(row, disable) {
      // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.disable = disable
    },
    resetTemp() {
      let obj = {};
      this.headerList.forEach((item) => {
        obj[item.columnName] = defaultVal(item.entityType)
      })
      obj['manufacturerId'] = '';
      obj['devPolicyId']='';
      obj['productTypeId']='';
      this.temp =Object.assign({}, obj) // copy obj
    },
    handleCreate() {
      // 弹出添加框
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      // 保存提交
      this.$refs['dataForm'].validate(() => {
        devices.add(this.temp).then(() => {
          //this.list.unshift(this.temp)
          this.getList();
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '创建成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleUpdate(row) {
      // 弹出编辑框
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      // 更新提交
      this.$refs['dataForm'].validate(() => {
        const tempData = Object.assign({}, this.temp)
        devices.update(tempData).then(() => {
          this.getList();
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleDelete(rows) {
      // 多行删除
      this.delrows(devices, rows)
    },
    handleImport(){
      this.importFormVisible = true;
    },
    importData(){
      this.fullscreenLoading = true;
      this.$refs.upload.submit();
    },
    downloadTemplate(){
      let url = process.env.VUE_APP_BASE_API + '/devices/DownloadImportTemplate';
      window.open(url);
    },
    checkFileType(file){
      if(file.name.slice(-5).toLowerCase() != '.xlsx'){
        this.$notify({
          title: '提示',
              message: '只能导入Excel文件',
              type: 'warning',
              duration: 2000
        })
        return false;
      }
      return true;
    },
    handleUpload(res){
      let that = this;

      if(res.code == 200){
        this.$notify({
          title: '提示',
              message: '导入成功',
              type: 'success',
              duration: 2000
        });
        that.fullscreenLoading = false;
        that.importFormVisible = false;
        that.$refs.upload.clearFiles();

      } else {
        that.$alert(res.message, '导入失败', {
          callback: () => {
            that.fullscreenLoading = false;
            that.importFormVisible = false;
            that.$refs.upload.clearFiles();
          }
        });
      }
    }
  }
}
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
.m-15{
  margin:15px auto;
}
</style>
